var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"my-select"},[_c('search-customer-seller',{attrs:{"show-goback":false}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }